import React from 'react';
import useTakeoverContext from './takeover-context';
import './common.scss';
const msPerSec = 1000;
const msPerMin = msPerSec * 60;
const msPerHour = msPerMin * 60;
function getHMS(goalTimeMs) {
    const msDiff = goalTimeMs - Date.now();
    return {
        h: Math.floor(msDiff / msPerHour),
        m: Math.floor((msDiff % msPerHour) / msPerMin),
        s: Math.floor((msDiff % msPerMin) / msPerSec)
    };
}
function useHMS(goalTime) {
    const goalTimeMs = new Date(goalTime).getTime();
    const [hms, setHms] = React.useState(getHMS(goalTimeMs));
    React.useEffect(() => {
        const i = window.setInterval(() => setHms(getHMS(goalTimeMs)), msPerSec);
        return () => window.clearInterval(i);
    }, [goalTimeMs]);
    return hms;
}
export function Countdown({ goalTime }) {
    const { h, m, s } = useHMS(goalTime);
    return (React.createElement("div", { className: "countdown-numbers" },
        React.createElement("div", null,
            React.createElement("span", { className: "number" }, h),
            " hours"),
        React.createElement("div", null,
            React.createElement("span", { className: "number" }, m),
            " minutes"),
        React.createElement("div", null,
            React.createElement("span", { className: "number" }, s),
            " seconds")));
}
const numFormat = window.Intl.NumberFormat('en-US').format; // eslint-disable-line new-cap
export function Amount({ amount }) {
    return (React.createElement("div", { className: "amount-box" },
        React.createElement("div", { className: "message" }, "our goal is to raise"),
        React.createElement("div", { className: "amount" },
            "$",
            numFormat(amount))));
}
export function GiveButton({ text, url }) {
    const { close } = useTakeoverContext();
    return (React.createElement("a", { className: "btn primary", href: url, onClick: close }, text));
}
